import "core-js/modules/es.array.concat.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
export var updateSession = function updateSession(app, sessionId, fields, status, auth) {
  return finectAPI({
    version: 'v4',
    path: sessionId ? "applications/".concat(app, "/sessions/").concat(sessionId) : "applications/".concat(app, "/sessions"),
    method: sessionId ? 'PUT' : 'POST',
    credentials: auth,
    body: {
      items: fields,
      status: status
    },
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return data;
    }
  });
};